import moment, { Moment } from "moment";
import { DateTimeInterface } from "./types";

export default class DateUtility {
  public static getDate(date: DateTimeInterface): Moment {
    const dateString = date.date.substring(0, 23);
    return moment.tz(dateString, date.timezone);
  }
}
